module.exports = __webpack_public_path__ + "img/1-3.4d20098d.png";